import { escapeHtml } from '../escape.js';
import { editAttr, itemCollection, itemStr, labeledIntro, list, sectionOpen, str } from './helpers.js';
import type { JsonValueT, PatternSectionT } from '../../schema/index.js';

function itemValue(item: JsonValueT, key: string): JsonValueT | undefined {
  if (item === null || typeof item !== 'object' || Array.isArray(item)) return undefined;
  return item[key];
}

function scalarText(value: JsonValueT | undefined): string {
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return String(value);
  return '';
}

function renderFeatures(section: PatternSectionT, item: JsonValueT, planIndex: number): string {
  const value = itemValue(item, 'features');
  if (!Array.isArray(value)) return '';
  return value
    .map((feature, featureIndex) => {
      if (typeof feature !== 'string' || !feature) return '';
      const featurePath = `/plans/${planIndex}/features/${featureIndex}`;
      return `        <li class="ve-pricing__feature"${editAttr(section, featurePath)}>${escapeHtml(feature)}</li>`;
    })
    .filter(Boolean)
    .join('\n');
}

/** pricing — plan cards with prices, feature lists, and featured treatment. */
export function renderPricing(section: PatternSectionT): string {
  const heading = str(section.fields, 'heading');
  const label = str(section.fields, 'label');
  const plans = list(section.fields, 'plans')
    .map((item, index) => {
      const title = itemStr(item, 'title');
      const price = scalarText(itemValue(item, 'price'));
      const features = renderFeatures(section, item, index);
      const featured = itemValue(item, 'featured') === true || itemValue(item, 'highlighted') === true;
      if (!title && !price && !features) return '';
      let modifier = '';
      if (featured) modifier = ' ve-pricing__plan--featured';
      const planPath = `/plans/${index}`;
      const lines = [`    <article class="ve-pricing__plan${modifier}"${editAttr(section, planPath)}>`];
      if (title) lines.push(`      <h3 class="ve-pricing__title">${escapeHtml(title)}</h3>`);
      if (price) lines.push(`      <p class="ve-pricing__price">${escapeHtml(price)}</p>`);
      if (features) lines.push(`      <ul class="ve-pricing__features">\n${features}\n      </ul>`);
      lines.push('    </article>');
      return lines.join('\n');
    })
    .filter(Boolean)
    .join('\n');

  const parts: string[] = [
    sectionOpen(section),
    ...labeledIntro(section, 'pricing', heading, label),
    itemCollection(section, 'div', 've-pricing__plans', '/plans', plans),
    '</section>',
  ];
  return parts.join('\n');
}
